<ng-template #textTemplate>{{tooltipText}}</ng-template>
@if (tooltipTemplate || tooltipText) {
    <div
            class="cs-tooltip-icon--container"
            [class.cs-tooltip-icon--small]="size === 'small'"
            [class.cs-tooltip-icon--large]="size === 'large'">
        @if (tooltipTemplate || (triggerOnClick && tooltipText)) {
            <div
                    class="cs-tooltip-icon--container-inner"
                    [csTooltip]="tooltipTemplate || textTemplate"
                    [csTooltipPosition]="tooltipPosition"
                    [csTooltipDisabled]="disabled"
                    [csTooltipProgrammatic]="triggerOnClick"
                    [csTooltipScrollable]="scrollable"
                    #tooltipRef="csTooltip"
                    (click)="onIconClick($event)"
                    (opened)="opened.emit()">
                <mat-icon fontSet="cs-icon"
                          fontIcon="cs-icon-info-circle"
                          class="cs-tooltip-icon--off-icon"></mat-icon>
                <mat-icon fontSet="cs-icon"
                          fontIcon="cs-icon-info-i"
                          class="cs-tooltip-icon--on-icon"></mat-icon>
            </div>
        }
        @if (!tooltipTemplate && tooltipText && !triggerOnClick) {
            <div
                    class="cs-tooltip-icon--container-inner"
                    [matTooltip]="tooltipText"
                    [matTooltipDisabled]="disabled">
                <mat-icon fontSet="cs-icon"
                          fontIcon="cs-icon-info-circle"
                          class="cs-tooltip-icon--off-icon"></mat-icon>
                <mat-icon fontSet="cs-icon"
                          fontIcon="cs-icon-info-i"
                          class="cs-tooltip-icon--on-icon"></mat-icon>
            </div>
        }
    </div>
}
